module.exports = __webpack_public_path__ + "img/corneal-staining-1.2bd0ff8d.jpg";